// Routes are now publicly accessible.
// The soft-login prompt (useSoftLogin + SoftLoginModal) lives in Layout
// and fires based on page-view count and time-on-site thresholds.
export default function ProtectedRoute({ children }) {
  return children;
}
